import { InteractiveItem, type InteractiveItemOptions } from "./InteractiveItem";
import { useToyCollection } from "../stores/useToyCollection";

export type ToyOptions = InteractiveItemOptions;

export class Toy extends InteractiveItem {
	constructor({ onCollect, radius = 0, ...rest }: ToyOptions) {
		const { id } = rest;
		useToyCollection.getState().registerToy(id);

		super({
			...rest,
			radius,
			onCollect: () => {
				const newlyCollected = useToyCollection.getState().collectToy(id);

				if (newlyCollected && typeof onCollect === "function") {
					onCollect();
				}
			},
		});
	}
}
